export default {"src":"/_next/static/media/for-founders-icon.34578fc4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};